package com.flowyride.core.domain.gpx

/** A ready-to-save GPX file. */
data class GpxDocument(
    val fileName: String,
    val content: String,
) {
    companion object {
        const val MIME_TYPE = "application/gpx+xml"
        const val EXTENSION = "gpx"
    }
}
